<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <ion-list>
            <ion-item class="ion-margin-bottom" lines="none">
              <ion-label position="floating">Select Holiday Date</ion-label>
              <ion-datetime
                type="text"
                v-model="date"
                placeholder="Select Date"
              ></ion-datetime>
              <ion-button fill="solid" slot="end" @click="confirmSMS">
                Send SMS
              </ion-button>
            </ion-item>
            <ion-item>
              <ion-label class="ion-text-wrap">
                <h2>Preview</h2>
                <p>
                  "Respected Parents, school will remain closed on {{ date_f }}"
                </p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
        <ion-col size="12" v-if="classrooms">
          <ion-item lines="none">
            <h5>
              Select Recipients (Selected: {{ selected_recipients.length }})
            </h5>
          </ion-item>
          <ion-item lines="none">
            <ion-label>Select everyone</ion-label>
            <ion-checkbox
              checked
              slot="end"
              style="margin-bottom: 0; margin-top: 0"
              @ionChange="toggleAll($event)"
            ></ion-checkbox>
          </ion-item>

          <ion-card v-for="item of classrooms" :key="item.id">
            <ion-card-header style="padding-bottom: 0">
              <ion-card-title
                >Class {{ item.standard.name }} - {{ item.section.name }}
                <span v-if="user_ids[item.id]"
                  >({{
                    user_ids[item.id].length + "/" + item.students.length
                  }})</span
                >
              </ion-card-title>
              <ion-item lines="none">
                <ion-label>Select entire class</ion-label>
                <ion-checkbox
                  class="select-all-in-class"
                  checked
                  :value="item.id"
                  slot="end"
                  style="margin-bottom: 0; margin-top: 0"
                  @ionChange="toggleSelectAll(item, $event)"
                ></ion-checkbox>
              </ion-item>
            </ion-card-header>
            <ion-card-content>
              <ion-item>
                <ion-label position="floating">Students</ion-label>
                <ion-select
                  multiple
                  :interface-options="{ cssClass: 'full-screen' }"
                  v-model="user_ids[item.id]"
                  :value="getValues(item.students)"
                >
                  <ion-select-option
                    v-for="student of item.students"
                    :key="student.id"
                    :value="student.user_id"
                  >
                    {{ `${student.user.user_detail.name}` }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import BaseLayout from "../../../Base/BaseLayout.vue";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonCardContent,
  IonSelect,
  IonSelectOption,
  loadingController,
  alertController,
  toastController,
} from "@ionic/vue";

import moment from "moment";

export default {
  components: {
    BaseLayout,
    IonGrid,
    IonRow,
    IonCol,
    IonList,
    IonItem,
    IonLabel,
    IonDatetime,
    IonButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCheckbox,
    IonCardContent,
    IonSelect,
    IonSelectOption,
  },
  data() {
    return {
      title: "Send Holiday SMS",
      backLink: "sms.template",
      reloadable: false,

      date: new Date().toISOString(),

      user_ids: {},

      xhrError: {
        header: null,
        description: null,
      },
    };
  },

  computed: {
    date_f() {
      return moment(this.date).format("dddd, MMMM Do YYYY");
    },

    classrooms() {
      return this.$store.getters["holidaySMS/allResources"];
    },

    selected_recipients() {
      let user_ids = [];
      for (let key in this.user_ids) {
        this.user_ids[key].forEach((element) => {
          user_ids.push(element);
        });
      }
      return user_ids;
    },
  },

  created() {
    this.fetchStudents();
  },

  methods: {
    getValues(students) {
      let values = [];

      for (let key in students) {
        values.push(students[key].user_id);
      }
      return values;
    },

    async toggleSelectAll(item, event) {
      let values = [];

      if (event.detail.checked) {
        for (let key in item.students) {
          values.push(item.students[key].user_id);
        }
      }

      this.user_ids[item.id] = values;
    },

    async toggleAll(event) {
      const toggles = document.querySelectorAll(".select-all-in-class");
      if (event.detail.checked) {
        for (let i = 0; i < toggles.length; i++) {
          toggles[i].checked = true;
        }
      } else {
        for (let i = 0; i < toggles.length; i++) {
          toggles[i].checked = false;
        }
      }
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    toaster(message) {
      const toast = toastController.create({
        message,
        duration: 3000,
        color: "primary",
      });

      return toast;
    },

    async confirmSMS() {
      const count = this.selected_recipients.length;
      const header = `Confirm`;
      const message = `Are you sure you want to send ${count} SMS(s)?`;
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Confirm",
          handler: () => {
            this.sendSMS();
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async sendSMS() {
      let data = {
        holiday_date: this.date_f,
        user_ids: this.selected_recipients,
      };
      const spinner = await this.loader("Sending...");
      spinner.present();

      try {
        await this.$store.dispatch("holidaySMS/sendSMS", data);
        spinner.dismiss();
        const toast = await this.toaster("SMS request queued");
        await toast.present();
        this.$router.replace({ name: "communication" });
      } catch (error) {
        spinner.dismiss();
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
      }
    },

    async selectAllStudents() {
      this.classrooms.forEach((classroom) => {
        this.user_ids[classroom.id] = [];
        classroom.students.forEach((student) => {
          this.user_ids[classroom.id].push(student.user_id);
        });
      });
    },

    async fetchStudents() {
      await this.$store.dispatch("holidaySMS/allResources");
      await this.selectAllStudents();
    },
  },
};
</script>

<style scoped></style>
